import { useDispatch, useSelector } from "react-redux";
import { downloadMonthlyTradeingExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useMonthlySecurityExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.securityCommission.monthlyTrade.downloadReportFetchState);
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMonthlyTradeingExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
